import { useAuth } from '../contexts/AuthContext.js';

/**
 * Convenience hook for authenticated fetch.
 * Attaches Authorization header automatically and handles token refresh.
 */
export function useAuthFetch() {
  const { authFetch, status } = useAuth();
  return {
    authFetch,
    // The status itself, not only the boolean: "not authenticated" covers
    // still-initialising, consent-required and hard error, and those need
    // different words in front of a user (and in a diagnostic).
    status,
    isAuthenticated: status === 'authenticated',
  };
}
